import {memo} from 'react';
import MyTocaLogoSvg from '../../assets/img/icons/redesign-icons/mytoca-logo.svg?react';

export const MyTocaLogo = memo(({className}: {className?: string}) => {
  return <MyTocaLogoSvg className={className} />;
});
MyTocaLogo.displayName = 'MyTocaLogo';
